<template>
  <div>
    <b-form-group :label="label" :class="{'no-margin-bottom': noMarginBottom}" style="text-align: initial !important;" :label-for="id" :description="description">
      <div>
      <!-- <b-form-input
        id="example-input"
        v-model="value"
        type="text"
        :placeholder="placeholder"
         autocomplete="off"
      ></b-form-input> -->
      <b-input-group-append>
      <b-form-datepicker :right="right" label-help="" :show-decade-nav="true" :reset-button="resetButtton" :label-reset-button="$t('reset')"
      :label-current-month="$t('current-month')" :label-next-year="$t('next-year')" :label-selected="$t('selected-date')" @shown="$emit('shown', $event)" @hidden="$emit('hidden', $event)"
      :label-next-month="$t('next-month')" :label-prev-year="$t('prev-year')" :label-prev-month="$t('prev-month')"  @input="$emit('input', $event)"
      :label-next-decade="$t('next-decade')" :label-prev-decade="$t('prev-decade')" :min="min ? min : dateAfterNow ? new Date() : null" :max="max ? max : dateBeforeNow ? new Date() : null"
      :label-no-date-selected="placeholder" v-model="localValue" :date-format-options="dateFormatOptions" :start-weekday="MONDAY_START_ID"
      :locale="$i18nHelpers.getNormalizedLocale()" :placeholder="placeholder" :state="state"></b-form-datepicker>
    </b-input-group-append>
  </div>

      <vuelidate-error :validator="validator" :parentValidators="parentValidators" :requiredErrorMsg="errorMsg" :state="state">
      </vuelidate-error>
    </b-form-group>
  </div>
</template>

<script>
import { BFormDatepicker, BFormGroup, BFormInvalidFeedback, BInputGroupAppend, BFormInput } from 'bootstrap-vue'
import VuelidateError from '@/components/base/forms/VuelidateError'

const compName = 'base-datepicker'
const MONDAY_START_ID = 1

export default {
  components: {
    BFormDatepicker,
    BFormGroup,
    BFormInvalidFeedback,
    VuelidateError,
    BInputGroupAppend,
    BFormInput
  },
  props: {
    value: [Date, String],
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default () {
        return this.$t('datepicker-ph')
      }
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default () {
        return this.$t('labelNoDateSelected')
      }
    },
    validator: {
      type: Object,
      required: false,
      default: null
    },
    parentValidators: {
      type: Object,
      required: false,
      default: null
    },
    dateBeforeNow: Boolean,
    dateAfterNow: Boolean,
    right: Boolean,
    resetButtton: Boolean,
    noMarginBottom: Boolean,
    min: [Date, String],
    max: [Date, String]
  },
  data () {
    return {
      id: null,
      localValue: null,
      dateFormatOptions: { day: 'numeric', month: 'numeric', year: 'numeric' },
      formatted: '',
      selected: '',
      MONDAY_START_ID
    }
  },
  mounted () {
    this.id = `${compName}${this._uid.toString()}`
  },
  created () {
    this.localValue = this.value
    this.$watch('localValue', value => {
      this.$emit('input', value)
    })
    this.$watch('value', value => {
      this.localValue = value
    })
  },
  methods: {
      onContext (ctx) {
        // The date formatted in the locale, or the `label-no-date-selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
      }
    }
}
</script>

<style lang="scss">
.b-calendar {
  .btn-outline-secondary {
    color: $gray !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseDatepicker.vue